export default __webpack_public_path__ + "static/21-cd6c143042cf4857a8099c13cba9edbf.jpg";